<template>
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.6277 19.8462C39.1686 19.8462 33.701 21.065 29.7235 24.9183M42.6277 19.8462V13.8205M42.6277 19.8462C45.2214 19.8462 48.9444 20.5315 52.3217 22.4988M28.819 49.9744C32.8331 54.5829 38.898 56 42.6277 56C48.5851 56 60.5 52.3846 60.5 37.9231C60.5 32.2484 58.6654 28.2438 56.076 25.4723M42.6277 13.8205H36.6701V9H47.9892V13.8205H42.6277ZM52.3217 22.4988L56.3296 18.0385L59.9041 21.0513L56.076 25.4723M52.3217 22.4988C53.6577 23.2771 54.9396 24.2559 56.076 25.4723M29.5212 30.0897H15.2234M29.5212 44.5513H10.4574M29.5212 37.3205H4.5M42.6277 25.4723V37.3205L52.3217 45.7564"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
